import Smartphones from 'Timesheet/views/TimesheetsImportView/containers/Smartphones'
import Tablets from 'Timesheet/views/TimesheetsImportView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const TimesheetsImportView = getCurrentDeviceView(Smartphones, Tablets)

export default TimesheetsImportView
